import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import ViewEmployee from "../view";
import ViewEmployeeSchedule from "./view";
import EditEmployeeSchedule from "./edit";
import { MODULE_EMPLOYEES } from "variables/constants";

const employeeScheduleRoutes = [
    generateCRUDRoutes({
        mainTitle: "Employee Schedules",
        basePath: "employees/:employeeId/schedules",
        mainComponent: <ViewEmployee />,
        layout: "/console",	   
        subTitle:"Employee Schedule",
        level:4,
        moduleId: MODULE_EMPLOYEES,  
    })
]

export default employeeScheduleRoutes;